export default {
  // SideBar
  itineraries: "Itineraries",
  events: "Events",
  service_types: "Service Types",
  suppliers: "Suppliers",
  agencies: "Agencies",
  agents: "Agents",
  sub_admins: "Sub Admins",
  hotels: "Hotels",
  regions: "Regions",
  itinerary_builder: "Itinerary Builder",
  library: "Library",
  user_type: "User Type",
  event_service_and_hotel: "Event Service & Hotel",

  // Breadcrumb
  profile: "Profile",
  my_account: "My Account",
  service_type: "Service Type",
  supplier: "Supplier",
  services: "Services",
  service: "Service",
  view: "View",
  region: "Region",
  add: "Add",
  edit: "Edit",
  dashboard: "Home",
  itinerary: "Itinerary",
  event: "Event",
  add_new_service: "Add New Service",
  agency: "Agency",
  agent: "Agent",
  sub_admin: "Sub Admin",
  terms_conditions: "Terms & Conditions",
  faq: "FAQs",
  privacy_policy: "Privacy Policy",
  terms_and_conditions: "Terms and Conditions",

  // Email
  email_placeHolder: "Please Enter Email",
  email_send: "Send Email",
  email: "Email",

  //common
  toast_filed: "Make sure that you haven't updated any fields.",
  corrupted_data: "Corrupted data. Some services and hotels could not be loaded.",
  logout_success_fully: "Logout successfully!",
  based_on_service: "Based on Services",
  please_wait: "Please wait ...",
  sure_want_to_delete: "Are you sure you want to delete",
  dashboard_title: "Dashboard",
  search_here: "Hit enter to search",
  description: "Description",
  inactive: "Inactive",
  no_found: "No found",
  setting: "Setting",
  action: "Actions",
  edited: "Edited",
  submit: "Submit",
  percentage: "%",
  search: "Search",
  status: "Status",
  active: "Active",
  cancel: "Cancel",
  delete: "Delete",
  sr_no: "Sr. No",
  first: "First",
  prev: "Prev",
  month: "Month",
  close: "Close",
  send: "Send",
  date: "Date",
  year: "Year",
  save: "Save",
  hours: "Hours",
  next: "Next",
  previous: "Previous",
  yes: "Yes",
  euro: "€",
  no: "No",
  confirm_remove: "Confirm remove",
  remove: "Remove",
  pdf: "PDF",
  doc: "DOC",
  data_not_found: "Data not found",

  // Auth
  your_account_disable: "Your account is disabled!",
  login_toast: "You have logged in successfully!",
  password_incorrect: "Password is incorrect!",
  invalid_cred: "Invalid email or password",
  user_not_found: "User not found!",
  logout: "Logout",

  // Terms & Conditions
  terms_conditions_delete: "Are you sure you want to delete",
  terms_conditions_drag: "You can drag and drop terms & conditions from the list",
  terms_conditions_management: "Terms & Conditions Management",
  terms_conditions_placeholder: "Terms & Conditions Title",
  terms_conditions_details: "Terms & Conditions Details",
  terms_conditions_editor: "Terms & Conditions Editor",
  terms_conditions_name: "Terms & Conditions",
  terms_condition: "T & C",
  terms_conditions_edit: "Edit T & C",
  terms_conditions_save: "Save T & C",
  terms_conditions_add: "Add T & C",

  // Agent
  agent_delete: "Are you sure you want to delete",
  agent_placeHolder: "Please Enter Agent",
  agent_commission: "Agent Commission",
  agent_detail_add: "Add Agent Detail",
  agent_management: "Agent Management",
  select_agency: "Select Agency",
  agent_email: "Agent Email",
  agent_edit: "Update Agent",
  agent_label: "Agent Name",
  agent_save: "Save Agent",
  agent_add: "Add Agent",
  search_agent: "Search Agent",

  // Agency
  agency_delete: "Are you sure you want to delete",
  location_placeholder: "Please Enter Location",
  agency_placeHolder: "Please Enter Agency",
  agency_management: "Agency Management",
  agency_location: "Agency Location",
  agency_address: "Agency Address",
  agency_edit: "Update agency",
  agency_label: "Agency Name",
  agency_save: "Save agency",
  agency_add: "Add agency",
  location: "Agency Address",
  search_agency: "Search Agency",

  // Service
  service_delete: "Are you sure you want to delete",
  service_description_label: "Enter Service Description...",
  service_schedule_add: "Add Service Schedule",
  price_per_person_label: "Price Per Person",
  service_management: "Services Management",
  internal_cost_label: "Internal Cost",
  external_cost_label: "External Cost",
  total_internal_cost_label: "Total Internal Cost",
  total_external_cost_label: "Total External Cost",
  service_details: "Service Details",
  service_edit: "Update Services",
  service_save: "Save Services",
  service_label: "Service Name",
  service_add: "Add Services",
  service_not_found: "Service Not Found",
  to: "To",
  subject: "Subject",
  search_service: "Search Service",
  override_external_cost: "Override External Cost",
  duplicate_service: "Duplicate Service",
  service_name: "Service Name",
  enter_service_name: "Enter service name",
  duplicate_service_description: "Are you sure you want to create duplicate service.",
  duplicating: "Duplicating...",
  confirm: "Confirm",
  service_desc: "Service Description",

  // Service-Type
  service_type_delete: "Are you sure you want to delete",
  service_type_management: "Service Type Management",
  service_type_edit: "Update Service Type",
  service_type_name: "Service Type Title",
  service_type_save: "Save Service Type",
  service_type_add: "Add Service Type",
  service_type_label: "Service Type",
  search_service_type: "Search Service Type",

  // Supplier
  supplier_delete: "Are you sure you want to delete",
  supplier_management: "Suppliers Management",
  supplier_edit: "Update Supplier",
  supplier_label: "Supplier Name",
  email_supplier: "Email Supplier",
  supplier_add: "Add Supplier",
  supplier_save: "Save Supplier",
  search_supplier: "Search Supplier",
  view_supplier: "View Supplier",
  supplier_services: "Services",
  search_supplier_service: "Search",
  view_price_updates: "View Price Updates",
  price_updates_chart_heading: "Price Updates",
  price_update_logs_heading: "Price Update Logs",
  price_update_log_updated_price: "Updated price",
  price_update_log_internal_cost: "Internal cost",
  price_update_log_external_cost: "External Cost",
  price_update_log_to: "to",
  price_update_log_load_more: "Load more",
  price_update_log_empty_chart: "No year-by-year prices yet.",
  price_update_log_empty_logs: "No internal or external price changes logged yet.",
  price_update_log_error_loading: "Could not load price data. Check Firestore rules and that you are signed in.",
  confirm_service_field_changes: "Are you sure you want to make changes?",

  // Region
  region_delete_prefix: "Are you sure you want to delete",
  region_management: "Region Management",
  region_edit: "Update Region",
  region_label: "Region Name",
  region_save: "Save Region",
  region_add: "Add Region",
  search_region: "Search Region",

  img: "Image",

  // Sub Admin
  sub_admin_delete: "Are you sure you want to delete",
  roles_permission: "Role and Permission",
  sub_admin_title: "Sub Admin Management",
  sub_admin_module_name: "Module Name",
  sub_admin_edit: "Update Sub Admin",
  sub_admin_save: "Save Sub Admin",
  sub_admin_add: "Add Sub Admin",
  sub_admin_view: "View Admin",
  sub_admin_name: "User Name",
  full_name: "Full Name",
  A_I: "Active/Inactive",
  add_check: "Add",
  search_sub_admin: "Search Sub Admin",

  // Event
  event_delete: "Are you sure you want to delete",
  event_management: "Event Management",
  event_duration: "Event Duration",
  select_region: "Select Region",
  event_details: "Event Details",
  event_add_new: "Add New Event",
  booking_date: "Booking Date",
  event_label: "Event Title",
  enter_notes: "Enter Notes",
  event_edit: "Update event",
  event_time: "Event Time",
  event_Save: "Save Event",
  event_date: "Event Date",
  event_add: "Add Event",
  event_day: "Event Day",
  duration: "Duration",
  hrs: "Hrs",
  notes: "Notes",
  day: "Day",
  event_drag_title: "You can drag and drop events from the list",
  search_event: "Search Event",

  // Event-Service
  event_service_drag_title: "You can drag and drop Services from the list",
  service_add_new: "Add New Service",
  update_service: "Update service",
  service_edit_add_lib: "Save & Duplicate to library",
  service_edit_update_lib: "Save & Update to Library",
  add_service: "Add service",
  event_service: "Event Service",
  service_list: "Service List",
  search_services: "Search Services",
  view_all: "View All",
  hide_all: "Hide All",
  service_description: "Enter Service Description...",

  //event-hotel
  hotel_list: "Hotel List",
  event_hotel: "Event Hotel",

  // Hotels
  hotel: "Hotel",
  hotel_management: "Hotel Management",
  add_hotel: "Add Hotel",
  add_new_hotel: "Add New Hotel",
  edit_hotel: "Edit Hotel",
  hotel_name: "Hotel Name",
  hotel_location: "Location",
  phone_number: "Contact Info",
  hotel_details: "Hotel Details",
  images: "Images",
  website: "Website",
  address: "Address",
  property_description: "Property Description",
  other_details: "Other Details",
  cancellation_policy: "Cancellation Policy",
  search_hotels: "Search Hotels",
  amenities: "Amenities",
  amenitiesNote: "Please ensure all amenities are applicable for this confirmation",
  drag_and_drop_images_caption: "You can drag and drop images here",
  room: "Room",
  room_number: "Room Number",
  room_category: "Room Category",
  confirmation_reference: "Confirmation Reference",
  bedding: "Bedding",
  nightly_room_rate: "Nightly Room Rate",
  currency: "Currency",
  guest_name: "Guest Name",
  number_of_guests: "Number Of Guests",
  check_in_day: "Check In Day",
  check_out_day: "Check Out Day",
  check_in_time: "Check In Time",
  check_out_time: "Check Out Time",
  room_description: "Room Description",
  room_notes: "Room Notes",
  internal_reference: "Internal Reference",
  confirm_remove_room: "Are you sure you want to remove",
  search_hotel: "Search Hotel",
  image_validation: "Image size should be less than 9 MB",
  booking_room: "Booking Room",
  booking: "Booking",

  // Itinerary
  service_booking_confirmation_details: "Service Booking Confirmation Details",
  service_booking_confirmation: "Service Booking Confirmation Details",
  itinerary_summer_total_price: "Total Price for Summer itinerary",
  create_itinerary_success: "Created Itinerary successfully.",
  itinerary_delete: "Are you sure you want to delete",
  itinerary_view_details: "View Itinerary Details",
  total_and_internal_cost: "Total External Cost",
  cost_per_participant: "Cost Per Participant",
  itinerary_management: "Itinerary Management",
  one_agent_allowed: "Only one agent allowed",
  no_of_Participant: "No. of Participant(s)",
  itinerary_delete_label: "Delete Itinerary",
  itinerary_download: "Download Itinerary",
  itinerary_details: "Itinerary Details",
  agent_is_required: "Agent is required",
  participant_list: "Participants List",
  add_participants: "Add Participants",
  view_participants: "View Participants",
  participant_name_required_for_selected: "Enter a name for each selected participant.",
  participants_per_service_tooltip:
    "Participants for this service only.",
  participants_count_suffix: "Participant(s)",
  add_new_participant: "+ Add New Participant",
  participant_external_tag: "External",
  participant_days_label: "Days",
  at_least_one_participant: "Add at least one participant with a name.",
  participant_name_placeholder: "Participant name",
  service_provider: "Service Provider",
  service_time: "Service Time (00:00)",
  itinerary_save: "Save Itinerary",
  itinerary_view: "View Itinerary",
  itinerary_edit: "Edit Itinerary",
  itinerary_name: "Itinerary Name",
  itinerary_add: "Add Itinerary",
  itinerary_id: "Itinerary ID",
  total_price: "Total Price",
  participate: "Participate",
  participant: "Participant",
  no_of_days: "No. of Days",
  start_date: "Start Date",
  total_cost: "Total Cost",
  export_bd: "Export Bd",
  end_date: "End Date",
  invoice: "Invoice",
  version: "Version",
  members: "Members",
  step_1: "Step  1",
  step_2: "Step  2",
  step_3: "Step  3",
  send_to_axus: "Send to Axus",
  send_to_travefy: "Send to Travefy",
  last_edited_by: "Last edited by",
  select_supplier_warn: "After Drag service please select Supplier",
  select_supplier_service: "Please Select Supplier in Service",
  search_itinerary: "Search Itinerary",
  edited_cost: "Edited Cost",
  edited_cost_greater_than_zero: "Edited cost must be greater than 0.",
  file_size_9_mb_validation: "Total File size should be less than 9 MB",
  max_2_files_validation: "Maximum 2 files are allowed",
  hotel_email_required: "Hotel email is required",
  send_to_auxs_travefy: "Send to Itinerary PDF, Axus & Travefy",
  axus: "Axus",
  name_quotation: "Name",
  view_updated_successfully: "View Updated Successfully",

  shift_all_bookings_label: "Shift all bookings according to new start date, preserving order",
  pre: "Pre",
  post: "Post",
  pre_itinerary: "Pre",
  post_itinerary: "Post",
  action_required: "Action Required",
  warning: "Warning",
  continue: "Continue",
  clear_adjust_pre_post_msg: "You need to clear or adjust Post items in order to send the itinerary.",
  post_items_warning_msg: "Post items will not be sent to this service. Only day items will be sent.",

  // Export - Bd
  cartasi_tool_tip: "Here, You can add CC Fee in Euro or Percentage",
  export_bd_percentage_amount: "Percentage or Amount",
  export_bd_agent_commission: "Agent Commission",
  select_booker: "Select Booker",
  export_bd_title: "Export BD",
  export_bd_cartasi: "CC Fee",
  booker: "Booker",



  // Book-Service-Hotel
  nothing_to_update: "Nothing to update.",
  service_details_updated: "Service details updated successfully",
  hotel_details_updated: "Hotel details updated successfully",
  service_date_and_time_updated: "Service date and time updated successfully",
  start_date_and_time_error: "Start date or time cannot be same as previous",
  confirm_confirmation_msg: "Are you sure you want to confirm Service?",
  cancel_confirmation_msg: "Are you Sure you want to cancel?",
  book_hotel_and_services: "Book Services and Hotels",
  room_booked_successes_fully: "Room booked successfully",
  cancel_booking: "Cancel Confirm Booking",
  confirm_booking: "Confirm Booking",
  generate_email: "Generate Email",
  bunk_beds: "Bunk Beds",
  king: "King",
  queen: "Queen",
  twin: "Twin",
  double: "Double",
  single: "Single",
  european_queen: "European Queen",
  three_kings: "Three Kings",
  two_kings: "Two Kings",
  two_queens: "Two Queens",
  two_doubles: "Two Doubles",
  two_twins: "Two Twins",
  two_singles: "Two Singles",
  four_post: "Four Post",
  matrimonial: "Matrimonial",
  french_beds: "French Beds",
  book_services: "Book Services",
  book_hotel: "Book Hotel",
  hotel_not_available: "Hotel Not Available",
  serviceAndHotel: "Service & Hotel",

  // AVES
  enter_aves_number: "Enter AVES Number",
  aves_number: "Aves Number",
  aves_details: "AVES Details",
  aves_add: "Add AVES",
  aves_edit: "Edit AVES",

  // Filter
  search_creator: "Hit enter to search creator",
  by_creator: "By Creator",
  clear_all: "Clear All",
  filter: "Filter",
  apply: "Apply",
  service_type_filter: "Service Type ",

  // Comment Thread
  ei_notes_added_toast: "EI Notes added successfully",
  ei_notes_updated_toast: "EI Notes updated successfully",
  ei_notes_deleted_toast: "EI Notes deleted successfully",
  add_comments_placeholder: "Add your comments..",
  unsupported_file_type: "Unsupported File Type:",
  message_thread: "Message Thread",
  comment_thread: "Comment Thread",
  supplier_chat: "Supplier Chat",
  new_message: "New Message",
  agent_chat: "Agent Chat",
  type_msg: "Type message",
  yesterday: "Yesterday",
  days_ago: "days ago",
  ei_notes: "EI Notes",
  today: "Today",
  chat: "Chat",
  add_booking_notes: "Add Booking Notes",
  booking_note: "Booking Note",
  are_you_sure_you_want_to_delete_this_note: "Are you sure you want to delete this note?",
  delete_booking_note: "Delete Booking Note",
  update: "Update",
  email_hotel: "Email Hotel",
  press_enter_to_save: "Press enter to save",

  // Generate Quotation
  generate_invoice_tool_tip: "First confirm agent commission in Export Bd",
  term_condition_already_exist: "Term & condition already exists.",
  generate_quotation_details: "Generate Quotation Details",
  you_can_message_here: "You Can Message Here",
  generate_quotation: "Generate Quotation",
  generate_invoice: "Generate Invoice",
  attach_document: "Attach Document",
  enter_msg: "Enter Message",
  send_msg: "Send Message",
  generate: "Generate",
  quotation: "Quotation",
  message: "Message",

  // Notifications
  notification: "Notifications",

  // Pagination
  rows_par_page: "Rows per page :",

  // User Profile - MyAccount
  name: "Name",

  // User Profile - Settings
  confirm_password: "Confirm Password",
  old_password: "Old Password",
  new_password: "New Password",
  password: "Password",

  // Forgot Password
  forgot_pass_description: "Enter your email address and you will receive a reset password link on your inbox",
  forgot_pass_title: "Forgot Password",
  back_to_login: "Back to login",

  // Login
  login: "Login",

  // Reset
  re_enter_pass: "Re-Enter New Password",
  reset_password: "Reset Password",
  save_password: "Save Password",
  set_password: "Set Password",

  // Dashboard
  complete_itineraries: "Completed Itineraries",
  upcoming_itineraries: "Upcoming Itineraries",
  total_itineraries: "Total Itineraries",
  monthly_revenue: "Monthly Revenue ($)",
  yearly_revenue: "Yearly Revenue ($)",
  total_service: "Total Services",
  total_revenue: "Total Revenue",
  current_month: "Current Month",
  last_6_months: "Last 6 Months",
  current_year: "Current Year",
  total_events: "Total Events",
  last_month: "Last Month",
  last_year: "Last Year",
  monthly: "Monthly",
  custom: "Custom",
  yearly: "Yearly",
  start: "Start",
  end: "End",
  jan: "JAN",
  feb: "FEB",
  mar: "MAR",
  apr: "APR",
  may: "MAY",
  jun: "JUN",
  jul: "JUL",
  aug: "AUG",
  sep: "SEP",
  oct: "OCT",
  nov: "NOV",
  dec: "DEC",

  // Insurance Service
  insurance_name: "Insurance Name",
  company: "Company",
  policy_type: "Policy Type",
  effective_date: "Effective Date",
  toll_free_phone_num: "Toll Free Phone Number",
  price: "Price",
  internal_non_client_fields: "Internal Non-Client Facing Fields",
  visible_to_collaborators: "Visible to collaborators if booking is unlocked",
  salability: "Salability",
  last_reviewed_by: "Last Reviewed By",
  internal_notes_placeholder: "Internal Notes - Not visible to travellers or collaborators outside of your organization",

  // other service form
  priority: "Priority",
  low: "Low",
  high: "High",
  collaborator_notes_placeholder: "Collaborator Notes - Not visible to Travellers but visible to all collaborators",
  pre_travel: "Pre Travel",
  post_travel: "Post Travel",
  time: "Time",

  // air service form
  flight_segment: "Flight Segment",
  airline: "Airline",
  operated_by: "Operated By",
  flight_number: "Flight Number",
  departure_city: "Departure City",
  arrival_city: "Arrival City",
  departure_day: "Departure Day",
  arrival_day: "Arrival Day",
  departure_time: "Departure Time",
  arrival_time: "Arrival Time",
  departure_terminal: "Departure Terminal",
  arrival_terminal: "Arrival Terminal",
  passengers: "Passengers",
  passenger: "Passenger",
  passenger_name: "Passenger Name",
  seat: "Seat",
  class: "Class",
  freq_flyer_no: "Freq. Flyer No.",
  ticket_no: "Ticket No.",
  record_locator: "Record Locator - Necessary to receive flight notifications",
  additional_title_info: "Additional Title Info",
  checkin_url: "Check-in URL",
  add_passenger: "Add Passenger",

  // conceirge
  start_day: "Start Day",
  end_day: "End Day",
  start_time: "Start Time",
  end_time: "End Time",
  confirmed_for: "Confirmed For",
  confirmed_by: "Confirmed By",
  payment: "Payment",

  // cruise
  cruise_line: "Cruise Line",
  name_of_ship: "Name Of Ship",
  cabin: "Cabin",
  add_cabin: "Add Cabin",
  cabin_category: "Cabin Category",
  cabin_number: "Cabin Number",
  no_of_guests: "Number Of Guests",
  internal_references: "Internal References",
  embarkation: "Embarkation",
  departure: "Departure",
  port_of_calls: "Port  of Calls",
  port_city: "Port City",
  disembarkation: "Disembarkation",
  add_port: "Add Port",
  arrival: "Arrival",

  // tour/activity
  confirmation_number: "Confirmation Number",
  meeting_point: "Meeting Point",
  contact_info: "Contact Info",

  // transportation
  select_transit_type: "Select Transit Type",
  transit_type: "Transit Type",
  service_title: "Service Title",
  departure_location: "Departure Location",
  arrival_location: "Arrival Location",
  service_class: "Service Class",
  seat_assignments: "Seats Assignments",
  train_type: "Train Type",
  train_number: "Train Number",
  coach_number: "Coach Number",
  pickup: "Pickup",
  vehicle: "Vehicle",
  drop_off: "Drop Off",
  ferry: "Ferry",
  rail: "Rail",
  rental_car: "Rental Car",
  transfer: "Transfer",
  other: "Other",
  number_of_passengers: "Number Of Passengers",

  // hotels
  add_room: "Add Room"
};
